// The fixed greeting every dialog opener starts with; [role]/[company] are
// substituted per respondent server-side. Single source for the two PM-facing
// previews (framing card and per-dialog opener preview).
export function openerGreeting(withOrg: boolean): string {
  return `Hi, thanks for joining! I'd love to hear about your work as a [role]${withOrg ? ' at [company]' : ''}. If I've got that wrong, just say. `;
}
